import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";

@Component({
  selector: 'app-celsus',
  imports: [Link],
  templateUrl: './celsus.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './celsus.scss',
})
export class Celsus {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Celsus`);
    this.dynamicTitle.description(`Celsus argued that Jesus performed miracles through the power of demons, and that his followers were gullible and easily deceived.`);
  }
}
